import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';
import { moduleConfig } from './config';

export type RoleType = 'ADMIN' | 'USER' | 'CLIENT' | 'GUEST';

export interface User {
  id: number;
  userEmail: string;
  userDisplayName?: string;
  userFirstName: string;
  userLastName: string;
  userIsActive: boolean;
  role: RoleType;
  createdAt: string;
  updatedAt?: string;
}

export interface UsersResponse {
  data: User[];
  total: number;
  page: number;
  limit: number;
}

export const useUsers = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<User[]>(
    `${moduleConfig.module.api.list}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    users: data || [],
    total: data?.length || 0,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useUser = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<User>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    user: data,
    isLoading,
    isError: error,
    mutate,
  };
};

